import { render, staticRenderFns } from "./MiniviewTabs.vue?vue&type=template&id=0fbda893"
import script from "./MiniviewTabs.vue?vue&type=script&lang=js"
export * from "./MiniviewTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports